<!--<ipos-sidebar></ipos-sidebar>-->
<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 bg-head-light mb-2">
          <div class="col-lg-6 col-5">
            <h1 style="justify-content: center;" class="h3 mb-0">Card Transaction Report</h1>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <ol class="breadcrumb breadcrumb-links breadcrumb-dark mt-2">
                <li class="breadcrumb-item">
                  <i class="fas fa-home"></i>
                </li>
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Card Transaction Report
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-lg-6 col-7 text-right">
            <div class="quick-filter">
              <input type="text" (keyup)="onQuickFilterChanged()" class="form-control" [(ngModel)]="quickSearchValue"
                placeholder="search..." /><i class="fa fa-search"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-3">
    <div>
      <ag-grid-angular #agGrid style="height: 73vh;" class="ag-theme-balham" [rowData]="rows" [rowHeight]="40" [pagination]="true" [enableCellTextSelection]="true"
        [columnDefs]="columnDefs" (modelUpdated)="onModelUpdated()" (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)">
      </ag-grid-angular>
    </div>
  </div>
</article>